export default __webpack_public_path__ + "static/media/FTTH-removebg.b32c54b1.png";